import React, { useState } from "react";
import { Box, Typography, Button, Dialog, DialogContent } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PlataformaSelector from "./PlataformaSelector";

const GuiaHeader = ({ plataforma }) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                position: "fixed",
                top: 0,
                left: 0,
                padding: "16px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                pt: 3,
                pb: { xs: 2, md: 3 },
                backgroundColor: 'white',
                zIndex: 1000,
            }}>
                <Typography
                    variant="h5"
                    sx={{
                        fontSize: "28px",
                        fontWeight: "medium",
                        color: "#000",
                        ml: { xs: 6, md: 35.5 },
                        textAlign: 'left',
                        flex: 1,
                        mr: { xs: 3, md: 0 },
                        mt: { xs: -0.9, md: 0 }
                    }}
                >
                    Implementación en <span style={{ color: "#0F52BD" }}>{plataforma}</span>
                </Typography>

                <Button
                    variant="outlined"
                    startIcon={<MenuBookIcon />}
                    onClick={() => setModalOpen(true)}
                    sx={{
                        textTransform: "none",
                        fontWeight: "medium",
                        color: "#0F52BD",
                        borderColor: "#0F52BD",
                        fontSize: "16px",
                        px: 3,
                        py: 1.5,
                        borderWidth: "2px",
                        mr: 2,
                        mt: { xs: -0.4, md: 0 },
                        whiteSpace: "nowrap",
                    }}
                >
                    <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
                        Guías de implementación
                    </Box>
                </Button>

                <Button
                    variant="outlined"
                    href="/dashboard/home"
                    sx={{
                        textTransform: "none",
                        fontWeight: "medium",
                        color: "#0F52BD",
                        borderColor: "#0F52BD",
                        fontSize: "16px",
                        px: 3,
                        py: 1.5,
                        borderWidth: "2px",
                        mr: { xs: 0, md: 5 },
                        mt: { xs: -0.4, md: 0 },
                    }}
                >
                    Volver
                </Button>
            </Box>

            <Dialog 
                open={modalOpen} 
                onClose={() => setModalOpen(false)} 
                maxWidth="lg" 
                fullWidth 
                PaperProps={{ 
                    sx: { 
                        borderRadius: 3,
                        p: 0,
                        m: 0,
                        overflow: "hidden",
                        "& .MuiDialogContent-root": {
                            padding: 0,
                            margin: 0,
                        }
                    } 
                }}
            >
                <DialogContent sx={{ 
                    padding: 0,
                    margin: 0,
                    "&:first-of-type": {
                        paddingTop: 0,
                    }
                }}>
                    <PlataformaSelector />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default GuiaHeader;
